<template>
  <v-menu :close-on-content-click="false" nudge-bottom="15" offset-y v-model="visible">
    <template v-slot:activator="{}">
      <a href="add-tag" class="add-link" @click.prevent="visible = true">Lägg till</a>
    </template>
    <v-card class="pa-2 the-card">
      <div class="tags">
        <v-chip
          class="tag-chip"
          v-for="tag in allTags"
          :key="tag.id"
          small
          :color="getTagColor(tag.color)"
          label
          :outlined="!isSelected(tag)"
          :text-color="isSelected(tag) ? 'white' : getTagColor(tag.color)"
          @click="onClickTag(tag)"
        >
          {{ tag.name }}
        </v-chip>
      </div>
      <!-- <v-divider/> -->

      <v-card-actions>
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="#145074"
          size="20"
        ></v-progress-circular>
        <v-spacer></v-spacer>

        <v-btn small text :to="{ name: 'TagsAdmin' }"> Hantera taggar </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { getTagColor } from '@/assets/data/colors.js'

export default {
  name: 'AddTag',
  props: {
    allTags: Array,
    selectedTags: Array,
  },
  data() {
    return {
      visible: false,
      loading: false,
    }
  },
  created() {
    document.addEventListener('tags-loading', (e) => {
      switch (e.detail.state) {
        case 'tags-loading-start':
          this.loading = true
          break
        case 'tags-loading-stop':
          this.loading = false
          break
        default:
          this.loading = false
          break
      }
    })
  },
  methods: {
    getTagColor,
    isSelected(tag) {
      return this.selectedTags.map((t) => t.tagId).includes(tag.id)
    },
    onClickTag(tag) {
      if (this.isSelected(tag)) {
        this.$emit('remove-tag', tag)
      } else {
        this.$emit('add-tag', tag)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.the-card {
  width: 400px;
}
.tag-chip {
  margin: 3px;
  cursor: pointer;
}
.add-link {
  font-size: 0.875rem !important;
  letter-spacing: 0.0178571429em !important;
  line-height: 1.25rem;
  text-decoration: none;
  color: #2196f3;
  margin-left: 3px;
  white-space: nowrap;
}
</style>
